// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__rNRrs","loading":"spinner_loading__1YrRd","noAnimation":"spinner_noAnimation__36Mmm"};